//https://reactjs.org/docs/faq-functions.html
import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import AuthService from "../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import Edit from "@material-ui/icons/Edit";

/**
 * Author Darya OREL
 * Page avec tous les ressources d'un monde
 */

class WorldResources extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      modalAdd: false,
      modalEdit: false,
      idResourceEdit: "",
      nameResourceEdit: "",
      typeResourceEdit: 0,
      urlResourceEdit: "",
      descriptionResourceEdit: "",
      positionWorldEdit: "",
      data: [],
      title: "",
      type: "",
      url: "",
      description: "",
      prevData: []
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitEditModal = this.handleSubmitEditModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeSelectEdit = this.handleChangeSelectEdit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
  }

  /**
   * Darya Orel
   * Affichage des messages d'erreurs
   * @param err erreur
   */
  notifyError(err) {
    toast.error(err);
  }

  /**
   * Darya Orel
   * Affichage des messages de success
   * @param msg message
   */
  notifySuccess(msg) {
    toast.success(msg);
  }

  /**
   * Darya Orel
   * Affichage des messages d'erreurs
   * @param err erreur
   */
  notifyInfo(err) {
    toast.info(err);
  }

  /**
   * Darya Orel
   * Chargement de la page
   * @param err erreur
   */
  componentDidMount() {
    this.fetchResources(this);
  }

  /**
   * Darya Orel
   * Rechargement de la page
   * @param err erreur
   */
  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchResources(this);
      this.forceUpdate();
    }
  }

  /**
   * Darya Orel
   * Ouverture et fermeture du modal d'ajout
   */
  toggle() {
    this.setState(prevState => ({
      modalAdd: !prevState.modalAdd
    }));
  }

  /**
   * Darya Orel
   * Ouverture et fermeture du modal d'édition
   */
  toggleEditModal() {
    this.setState(prevState => ({
      modalEdit: !prevState.modalEdit
    }));
  }

  /**
   * Darya Orel
   * Edition d'une ressource
   */
  edit(event) {
    this.setState({
      idResourceEdit: event.currentTarget.getAttribute("data-id"),
      nameResourceEdit: event.currentTarget.getAttribute("data-title"),
      typeResourceEdit: event.currentTarget.getAttribute("data-type"),
      urlResourceEdit: event.currentTarget.getAttribute("data-url"),
      descriptionResourceEdit: event.currentTarget.getAttribute(
        "data-description"
      )
    });
    this.toggleEditModal();
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Suppression d'une ressource
   */
  delete(event) {
    let idToDelete = event.currentTarget.getAttribute("data-id");
    let titleToDelete = event.currentTarget.getAttribute("data-title");

    if (
      confirm(
        "Etes-vous sur de bien vouloir supprimer la ressource : " +
          titleToDelete
      )
    ) {
      this.Auth.httpRequest(
        "delete",
        "api/worldresource/delete?id=" + idToDelete
      )
        .then(datas => {
          var msg = "La ressource a été supprimée avec succès";
          this.notifySuccess(msg);
        })
        .catch(error => {
          this.notifyError("Erreur de suppression de la ressource");
        })
        .finally(() => {
          this.fetchResources(this);
        });
    }
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Récuperation de tous les ressources d'un monde
   */
  fetchResources(thus) {
    thus.Auth.httpRequest(
      "GET",
      "api/worldresource/selectWorldResources?worldId=" + thus.props.params.id
    )
      .then(function(datas) {
        if (Array.isArray(datas.data) || datas.data.length > 0) {
          thus.setState({
            data: datas.data
          });
        } else {
          thus.setState({
            data: []
          });
        }
      })
      .catch(error => {
        this.notifyError("Erreur de récuperation des ressources");
      });
  }

  /**
   * Darya Orel
   * Récuperation du changement du champ
   */
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  /**
   * Darya Orel
   * Récuperation du changement du champ du select
   */
  handleChangeSelect() {
    var e = document.getElementById("type");
    var value = e.options[e.selectedIndex].value;
    this.setState({
      type: value
    });
  }


  /**
   * Darya Orel
   * Récuperation du changement du champ du select de l'édition
   */
  handleChangeSelectEdit() {
    var e = document.getElementById("typeResourceEdit");
    var value = e.options[e.selectedIndex].value;
    this.setState({
      typeResourceEdit: value
    });
  }
  /**
   * Darya Orel
   * Action lorsqu'on a cliquer sur le submit du modal d'ajout
   */
  handleSubmit(event) {
    this.Auth.httpRequest("POST", "api/worldresource/insert", {
      worldId: this.props.params.id,
      type: this.state.type,
      title: this.state.title,
      url: this.state.url,
      description: this.state.description
    })
      .then(datas => {
        var msg = "L'ajout de la ressource a été réalisé avec succès";
        this.notifySuccess(msg);
        this.setState({
          modalAdd: false,
          type: "",
          title: "",
          url: "",
          description: ""
        });
      })
      .catch(error => {
        this.notifyError("Erreur d'insertion du monde");
      })
      .finally(() => {
        this.fetchResources(this);
      });
    //  on soumet pas vraiment le formulaire
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Action lorsqu'on a cliquer sur le submit du modal d'édition
   */
  handleSubmitEditModal(event) {
    this.Auth.httpRequest("POST", "api/worldresource/update", {
      resourceId: this.state.idResourceEdit,
      type: this.state.typeResourceEdit,
      title: this.state.nameResourceEdit,
      url: this.state.urlResourceEdit,
      description: this.state.descriptionResourceEdit
    })
      .then(datas => {
        var msg = "La modification de la ressource a été réalisée avec succès";
        this.notifySuccess(msg);
        this.setState({
          modalEdit: false,
          typeResourceEdit: 0,
          nameResourceEdit: "",
          urlResourceEdit: "",
          descriptionResourceEdit: ""
        });
      })
      .catch(error => {
        this.notifyError("Erreur de modiication due la ressource");
      })
      .finally(() => {
        this.fetchResources(this);
      });
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Render fonction
   * @return la page à afficher
   */
  render() {
    let content, addResourceModal, editResourceModal;

    content = (
      <CardBody className="pb-0">
        <ToastContainer />
        <Table responsive striped bordered>
          <thead>
            <tr>
              <th>Id</th>
              <th>Nom</th>
              <th>Type</th>
              <th>Description</th>
              <th>URL</th>
              <th>Supprimer</th>
              <th>Éditer</th>
            </tr>
          </thead>
          <tbody>
            {this.state.data && this.state.data.length > 0 ? (
              this.state.data.map((object, index) => {
                let type;
                if (object.type === 0) type = "site";
                else if (object.type === 1) type = "vidéo";
                else if (object.type === 2) type = "livre";
                else type = "podcast";
                return (
                  <tr key={index}>
                    <td>{object.id}</td>
                    <td>{object.title}</td>
                    <td>{type}</td>
                    <td>{object.description}</td>
                    <td>{object.url}</td>
                    <td>
                      <a
                        href="#"
                        onClick={this.delete}
                        data-id={object.id}
                        data-title={object.title}
                      >
                        <i className="fa fa-trash text-danger" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="#"
                        onClick={this.edit}
                        data-id={object.id}
                        data-title={object.title}
                        data-type={object.type}
                        data-description={object.description}
                        data-url={object.url}
                      >
                        <Edit />
                      </a>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr />
            )}
          </tbody>
        </Table>
      </CardBody>
    );

    addResourceModal = (
      <div>
        <Modal
          isOpen={this.state.modalAdd}
          toggle={this.toggle}
          className="addResourceModal"
        >
          <form onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle}>
              Ajouter une ressource
            </ModalHeader>
            <ModalBody>
              <div>
                <label>Nom de la ressource:</label>
                <br />
                <input
                  required
                  type="text"
                  id="title"
                  style={{ width: "90%" }}
                  name="title"
                  value={this.state.title}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <label>Type:</label>
                <br />
                <select
                  required
                  defaultValue={"DEFAULT"}
                  onChange={this.handleChangeSelect}
                  id="type"
                >
                  <option hidden>Choissisez le type</option>
                  <option value={0}>Site</option>
                  <option value={1}>Vidéo</option>
                  <option value={2}>Livre</option>
                  <option value={3}>Podcast</option>
                </select>
              </div>
              <div>
                <label>Description:</label>
                <br />
                <textarea
                  required
                  type="text"
                  style={{ width: "90%" }}
                  rows="10"
                  id="description"
                  name="description"
                  value={this.state.description}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <label>URL:</label>
                <br />
                <input
                  required
                  type="text"
                  style={{ width: "90%" }}
                  id="url"
                  name="url"
                  value={this.state.url}
                  onChange={this.handleChange}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Ajouter
              </Button>{" "}
              <Button color="secondary" onClick={this.toggle}>
                Annuler
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );

    editResourceModal = (
      <div>
        <Modal
          isOpen={this.state.modalEdit}
          toggle={this.toggleEditModal}
          className="editResourceModal"
        >
          <form onSubmit={this.handleSubmitEditModal}>
            <ModalHeader toggle={this.toggleEditModal}>
              Modifier une ressource
            </ModalHeader>
            <ModalBody>
              <div>
                <h2>{this.state.nameResourceEdit}</h2>
              </div>
              <div>
                <label>Nom de la ressource:</label>
                <br />
                <input
                  required
                  type="text"
                  id="title"
                  name="nameResourceEdit"
                  style={{ width: "90%" }}
                  value={this.state.nameResourceEdit}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <label>Type:</label>
                <br />
                <select
                  required
                  onChange={this.handleChangeSelectEdit}
                  id="typeResourceEdit"
                  defaultValue={this.state.typeResourceEdit}
                >
                  <option value={0}>Site</option>
                  <option value={1}>Vidéo</option>
                  <option value={2}>Livre</option>
                  <option value={3}>Podcast</option>
                </select>
              </div>
              <div>
                <label>Description:</label>
                <br />
                <textarea
                  required
                  type="text"
                  id="description"
                  style={{ width: "90%" }}
                  rows="10"
                  name="descriptionResourceEdit"
                  value={this.state.descriptionResourceEdit}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <label>URL:</label>
                <br />
                <input
                  required
                  type="text"
                  id="url"
                  style={{ width: "90%" }}
                  name="urlResourceEdit"
                  value={this.state.urlResourceEdit}
                  onChange={this.handleChange}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Modifier
              </Button>{" "}
              <Button color="secondary" onClick={this.toggleEditModal}>
                Annuler
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );

    return (
      <div>
        <div className="animated fadeIn">
          <br />
          <Row>
            <Col xs="12" lg="12">
              <Card>
                <CardHeader>
                  <i className="fa fa-align-justify" /> Mondes
                  <Button
                    className="pull-right"
                    color="primary"
                    onClick={this.toggle}
                  >
                    <i className="fa fa-plus" /> Ajouter
                  </Button>
                </CardHeader>
                {content}
              </Card>
            </Col>
          </Row>
        </div>
        {addResourceModal}
        {editResourceModal}
      </div>
    );
  }
}

export default WorldResources;



// WEBPACK FOOTER //
// ./src/views/Worlds/WorldResources.js